import { inject } from '@angular/core';
import { CanActivateFn, Params, Router } from '@angular/router';
import { UserSessionStore } from '../services/user-session.store';

export const loginRedirectGuard: CanActivateFn = route => {
  const sessionStore = inject(UserSessionStore);
  const router = inject(Router);

  if (!sessionStore.isAuthenticated()) {
    return true;
  }

  const fromUrl = route.queryParamMap.get('fromUrl');
  if (!fromUrl) {
    return router.createUrlTree(['/']);
  }

  const [path, query] = fromUrl.split('?');
  const queryParams: Params = {};
  if (query) {
    for (const [key, value] of new URLSearchParams(query).entries()) {
      queryParams[key] = value;
    }
  }
  return router.createUrlTree([path], { queryParams });
};
